import type { GroupDetail } from 'models';
import type { GroupDetailScope } from '../../types';
import GroupDetailHeader from '../GroupDetailHeader';

type P = {
  group: GroupDetail;
  navigateToGroupDetailPageByKey: ({ id, key }: { id: string; key?: GroupDetailScope }) => Promise<void>;
};

const GroupDetailAnnouncementsHeader = ({ group, navigateToGroupDetailPageByKey }: P) => (
  <GroupDetailHeader
    group={group}
    navigateToGroupDetailPageByKey={navigateToGroupDetailPageByKey}
    scope="announcements"
  />
);

export default GroupDetailAnnouncementsHeader;
